import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n'

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.financial.breadcrumb.financial_label'),
  },
];
